<nav class="navbar navbar-light" style="text-align: center;">
    <div class="container-fluid text-center">
        <div class="row" style="text-align: center;">

            <div class="col-md-12">
                <a class="navbar-brand12" href="#">
                    <img src="assets/img/logo.png" alt="" style="width: 220px; height: auto;">
                </a>
            </div>

        </div>
    </div>
</nav>
<section class="gray-bg">
    <div class="container">
        <div class="container">
            <div class="log-box">
                <div style="text-align: center;" class="row">

                    <img src="assets/img/oops-warn.png" alt="" class="d-inline-block align-text-top">

                    <div class="row log-in-again-box">
                        <p style="font-weight: 200; font-size: 1.5rem;color: #e98f8fe6">
                            Login session has been expired.
                            <a class="link" style="cursor:pointer;font-size: 1.5rem; color: blue;"
                                (click)="logIn()">Click
                                here to Log In again.</a>
                        </p>

                    </div>
                </div>

            </div>
        </div>
    </div>
</section>